
import randomColor from '../helpers/RandomColor.js';

export default {
  props: {
    url: {
      type: String,
      default: '',
      required: false
    },

    /**
     * @values icons
     */
    icon: {
      /** @type {AlturaIcons} */
      type: String,
      default: 'user'
    },

    fullName: {
      type: String,
      default: ''
    },

    size: {
      type: [Number, String],
      default: '1'
    }
  },

  data () {
    return {
      hasImage: true
    };
  },

  computed: {
    color () {
      return randomColor(this.fullName);
    },

    letters () {
      const words = this.fullName.trim().split(' ');
      if (words.length === 1 && words[0].length === 0) { return '?'; }

      if (words.length === 1) { return words[0][0].toUpperCase(); }

      return words[0][0].toUpperCase() + words[words.length - 1][0].toUpperCase();
    }
  }
};
